module.exports = __webpack_public_path__ + "static/castledon-cca7e68858ecc5538b7ca88b4759484e.jpg";